module.exports = __webpack_public_path__ + "media/icons/success-22e7ae71.png";